// extracted by mini-css-extract-plugin
export default {"imageWrapper":"LL-z","twoColumnImage":"ML-z"};